const captionsButtonTemplate = ({accessBtnClosedCaption, closedCaptionIndex}) => `<button class="closed-caption-button ui control-button tertiary-button" name="ClosedCaption" type="button" title="${accessBtnClosedCaption}" tabindex="${closedCaptionIndex}">
   <span class="ui closed-caption-button-glyph"></span>
</button>`;

export default captionsButtonTemplate;
